import { FETCH_ADMIN_USER_META } from "../actionTypes";

export const fetchAdminUserMeta = payload => ({
  type: FETCH_ADMIN_USER_META,
  payload
});
